import type { IndexedSqlFile } from '../types/scriptBrowserTypes';

type ScriptBrowserApi = NonNullable<Window['electronAPI']>['scriptBrowser'];

type ListDirectoryRequest = Parameters<ScriptBrowserApi['listDirectory']>[0];
type ListDirectoryResult = Awaited<ReturnType<ScriptBrowserApi['listDirectory']>>;

type SelectDirectoryRequest = Parameters<ScriptBrowserApi['selectDirectory']>[0] | undefined;
type SelectDirectoryResult = Awaited<ReturnType<ScriptBrowserApi['selectDirectory']>>;

type ScanDirectoryRequest = Parameters<ScriptBrowserApi['scanDirectory']>[0];
type ScanDirectoryResult = Awaited<ReturnType<ScriptBrowserApi['scanDirectory']>>;

function getIpcInvoker(): NonNullable<Window['electronAPI']>['invoke'] | null {
  if (typeof window === 'undefined') return null;
  return window.electronAPI?.invoke ?? null;
}

function getScriptBrowserApi(): ScriptBrowserApi | null {
  if (typeof window === 'undefined') return null;
  return window.electronAPI?.scriptBrowser ?? null;
}

export async function listScriptBrowserDirectory(
  request: ListDirectoryRequest
): Promise<ListDirectoryResult> {
  const api = getScriptBrowserApi();
  if (api) return api.listDirectory(request);

  const invoke = getIpcInvoker();
  if (!invoke) return { success: false, entries: [], error: 'Script Browser API unavailable' };

  return invoke('script-browser-list-directory', request) as Promise<ListDirectoryResult>;
}

export async function selectScriptBrowserDirectory(
  request?: SelectDirectoryRequest
): Promise<SelectDirectoryResult> {
  const api = getScriptBrowserApi();
  if (api) return api.selectDirectory(request);

  const invoke = getIpcInvoker();
  if (!invoke) return { cancelled: true, error: 'Script Browser API unavailable' };

  return invoke('script-browser-select-directory', request) as Promise<SelectDirectoryResult>;
}

export async function scanScriptBrowserDirectory(
  request: ScanDirectoryRequest
): Promise<ScanDirectoryResult> {
  const api = getScriptBrowserApi();
  if (api) return api.scanDirectory(request);

  const invoke = getIpcInvoker();
  if (!invoke) {
    const empty: IndexedSqlFile[] = [];
    return { success: false, sqlFiles: empty, error: 'Script Browser API unavailable' };
  }

  return invoke('script-browser-scan-directory', request) as Promise<ScanDirectoryResult>;
}

